import React from 'react';
import uuidv4 from 'uuid';

import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';


const styles = theme => ({
    root: {
        height: '100%',
        width: 240,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
});

class EditZonaTipoPartida extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            id: this.props.tipopartida.id ? this.props.tipopartida.id : uuidv4(),
            elemId: this.props.elemNoCajaId ? this.props.elemNoCajaId : 0,
            descr: this.props.tipopartida.descr ? this.props.tipopartida.descr : this.props.alltipospartida[0].descr,
            activo: this.props.tipopartida.activo ? true : false,
            iTipoPartida: this.props.tipopartida.iTipoPartida ? this.props.tipopartida.iTipoPartida : this.props.alltipospartida[0].id,

        };
    };


    fillTiposPartida = () => {

        return this.props.alltipospartida.map(tp => {

            return (
                <option key={tp.id} value={tp.id}>{tp.descr}</option>
            );

        })
    };


    handleCheckboxChange = event => {
        this.setState({ activo: event.target.checked });
    };


    handleChangeTipoPartidaSelect = (event) => {

        const value = parseInt(event.target.value);

        this.setState({
            ...this.state,
            iTipoPartida: value,
            descr: this.props.alltipospartida.find(tp => tp.id === value).descr
        });
    };

    render() {
        const { classes } = this.props;

        return (

            <div className={classes.root}>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="iTipoPartida-placeholder">
                            Tipo Partida
                                </InputLabel>
                        <Select
                            native
                            value={this.state.iTipoPartida}
                            onChange={(event) => this.handleChangeTipoPartidaSelect(event)}
                            name="iTipoPartida"
                        >
                            {this.fillTiposPartida()}
                        </Select>
                    </FormControl>
                </div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.activo}
                                    onChange={this.handleCheckboxChange}
                                    color="primary"
                                />
                            }
                            label="Activo"
                        />
                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        const tipopartida = {
                            ...this.props.tipopartida,
                            id: this.state.id,
                            elemId: this.state.elemId,
                            descr: this.state.descr,
                            activo: this.state.activo ? 1 : 0,
                            iTipoPartida: this.state.iTipoPartida,
                        };

                        if (this.props.checkTipoPartida(tipopartida)) {

                            this.props.okHandler(tipopartida);
                            this.props.hideDialog();
                        };
                    }
                    }>Guardar</Button>
                </div>

            </div>
        );

    };


};

EditZonaTipoPartida.propTypes = {
    tipopartida: PropTypes.object.isRequired,
    tiposPartida: PropTypes.array.isRequired,
    alltipospartida: PropTypes.array.isRequired,
    elemNoCajaId: PropTypes.number.isRequired,
    okHandler: PropTypes.func.isRequired,
    checkTipoPartida: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};


export default withStyles(styles, { withTheme: true })(EditZonaTipoPartida);